import { LINKS, REVIEW_CARDS, REVIEW_IMAGES } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";
import { WhatsAppIcon } from "./icons";

const Frame = ({ testId, url, alt, caption, tall = false }) => (
  <figure
    data-testid={testId}
    className="group bg-white border border-[#0D3B3E]/10 p-2 transition-[border-color,transform,box-shadow] duration-500 hover:border-[#0D9488]/50 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(13,59,62,0.1)]"
  >
    <div className={`overflow-hidden bg-white ${tall ? "" : ""}`}>
      <img
        src={url}
        alt={alt}
        loading="lazy"
        className="w-full h-auto transition-transform duration-700 ease-out group-hover:scale-[1.015]"
      />
    </div>
    <figcaption className="px-3 py-3 border-t border-[#0D3B3E]/10 mt-2">
      <p className="text-[10px] font-mono tracking-[0.18em] text-[#0D9488]">{caption}</p>
    </figcaption>
  </figure>
);

const Reviews = () => (
  <section id="reviews" data-testid="google-reviews-section" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading number="05" title="Patient Reviews · Google" testId="google-reviews-heading" />
      <Reveal className="mb-10 -mt-4">
        <p className="text-sm sm:text-base text-slate-600 leading-relaxed max-w-2xl">
          Straight from Google — unedited words of patients who healed gently. Every review is five stars.
        </p>
      </Reveal>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
        {REVIEW_IMAGES.map((r, i) => (
          <Reveal key={r.author} delay={i * 0.08}>
            <Frame
              testId={`patient-google-review-frame-${i}`}
              url={r.url}
              alt={r.alt}
              caption={`${r.caption} — ${r.author}`}
            />
          </Reveal>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 gap-5 mt-5 max-w-4xl">
        {REVIEW_CARDS.map((r, i) => (
          <Reveal key={r.caption} delay={0.1 + i * 0.08}>
            <Frame
              testId={`patient-review-card-frame-${i}`}
              url={r.url}
              alt={r.alt}
              caption={r.caption}
              tall
            />
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10 flex flex-wrap items-center gap-4">
        <a
          data-testid="reviews-share-experience-btn"
          href={LINKS.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-[#0D3B3E] text-[#F8FAF8] text-xs font-mono tracking-[0.18em] rounded-full px-6 py-3.5 hover:bg-[#0D9488] transition-colors duration-300"
        >
          <WhatsAppIcon className="w-4 h-4" />
          SHARE YOUR EXPERIENCE
        </a>
        <p className="text-[10px] font-mono tracking-[0.2em] text-slate-500">
          VERIFIED REVIEWS · GOOGLE & CLINIC PATIENTS
        </p>
      </Reveal>
    </div>
  </section>
);

export default Reviews;
